export class CanvasTileCodec {
    constructor(canvas) {
        this._canvas = canvas;
    }
    get width() {
        return this._canvas.width;
    }
    get height() {
        return this._canvas.height;
    }
    async decodeAsync(r) {
        if (r instanceof Response) {
            const data = await this._decodeDataAsync(r);
            if (data) {
                const workingContext = this._canvas?.getContext("2d", { willReadFrequently: true });
                if (!workingContext) {
                    throw new Error("Unable to get 2d context");
                }
                this._render(workingContext, data);
                const imgData = workingContext.getImageData(0, 0, this._canvas.width, this._canvas.height);
                return await createImageBitmap(imgData);
            }
        }
        return null;
    }
}
//# sourceMappingURL=tiles.codecs.canvas.js.map